module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/cenicilla_pepino/curativa/vigold.png
// module id = 2100
// module chunks = 3